import React from 'react'
import { css } from '@emotion/core'

export default () => {}

export function DmcRow({ children, justify }) {
  justify = justify == null ? 'left' : justify
  const rowCss = css`
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: ${justify === 'left' ? 'flex-start' : 'flex-end'};
  `
  return <div css={rowCss}>{children}</div>
}
